import * as jQuery from 'jquery'
import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'html2Text' })
export class html2TextPipe implements PipeTransform {
  transform(html: string): string {
    return jQuery(html).text()
  }
}
